import { useEffect, useRef } from 'react';
import { IdHelper } from '../../../../../helpers/id.helper';

function MicromobilityCheckbox({
  id = IdHelper.newUniqueId('micromobility-checkbox-'),
  text,
  iconSrc = undefined,
  iconAltText = '',
  checked,
  className = '',
  ariaControls = undefined,
  onChange,
}: {
  id?: string;
  text: string;
  iconSrc?: string;
  iconAltText?: string;
  checked: boolean | undefined;
  className?: string;
  ariaControls?: string;
  onChange: (checked: boolean) => void;
}) {
  // === REFS ===
  const inputRef = useRef<HTMLInputElement>(null);

  // === EFFECTS ===
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = checked === undefined;
    }
  }, [checked]);

  // === EVENT HANDLERS ===
  function handleChange() {
    onChange(checked === undefined ? true : !checked);
  }

  return (
    <div className={`micromobility-checkbox form-check ${className}`}>
      <input id={id} ref={inputRef} type="checkbox" className="form-check-input" checked={checked} aria-controls={ariaControls} onChange={handleChange} />
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <label htmlFor={id} className="form-check-label fw-normal" onKeyUp={handleChange}>
        {iconSrc && <img className="micromobility-checkbox__icon me-1" src={iconSrc} alt={iconAltText} />}
        {text}
      </label>
    </div>
  );
}

export default MicromobilityCheckbox;
